import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IContentfulFileURL, IContentfulImage, IStaticMixedQuery } from 'src/types/contentful';
import ScreenSwap from './ScreenSwap';

interface HeroScreenSwapProps {
  staticScale?: boolean; // Use this property to scale the screens even on static pages
}

const HeroScreenSwap = ({ staticScale }: HeroScreenSwapProps): JSX.Element => {
  const assets = useStaticQuery<IStaticMixedQuery<IContentfulFileURL, IContentfulImage>>(graphql`
    {
      welcome: contentfulAsset(contentful_id: { eq: "4vCGvQ8xhdcQAxM6BJezcX" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      members: contentfulAsset(contentful_id: { eq: "gaAix1CPGL8GSn58su7Hs" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      feed: contentfulAsset(contentful_id: { eq: "4Xfj7879JhxbZAOKwh0Lhx" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      coursesVideo: contentfulAsset(contentful_id: { eq: "20VsrQRe3HESOj5HzcRThq" }) {
        file {
          url
        }
      }
      coursesVideoPoster: contentfulAsset(contentful_id: { eq: "74CickirvNGSiWdHS9GmqG" }) {
        file {
          url
        }
      }
      events: contentfulAsset(contentful_id: { eq: "3SYSaSS944zMAfaIuCO7jb" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      live: contentfulAsset(contentful_id: { eq: "5mp9jzwuooZOGJgjbfet0H" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      chat: contentfulAsset(contentful_id: { eq: "1BnlrziD8ffIMULwWK2v5U" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      analytics: contentfulAsset(contentful_id: { eq: "7lap2AULMSu5sA5N7m9RpR" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }

      welcomeMobile: contentfulAsset(contentful_id: { eq: "14fOt9G1Y7tdmJwG7DX5Na" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      membersMobile: contentfulAsset(contentful_id: { eq: "2iXi02qFBA5O2SI0JOy8mP" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      feedMobile: contentfulAsset(contentful_id: { eq: "3MUe2vqjzVlfbR6k8AoSKx" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      coursesMobile: contentfulAsset(contentful_id: { eq: "2Ut6NPT4GtqviiPmwiha8o" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      eventsMobile: contentfulAsset(contentful_id: { eq: "3K1qsvyzcoq8uKo3F0TYqb" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      liveMobile: contentfulAsset(contentful_id: { eq: "7cbhCeKaZEqtjNDo8Ly302" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      chatMobile: contentfulAsset(contentful_id: { eq: "GY0nJrvPEd3eOliNX1si5" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      analyticsMobile: contentfulAsset(contentful_id: { eq: "3pNNL4C9NgE6EBm1NOpAEZ" }) {
        gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  const screens = [
    {
      title: 'Welcome',
      image: assets.welcome.gatsbyImageData,
      mobileImage: assets.welcomeMobile.gatsbyImageData,
    },
    {
      title: 'Members',
      image: assets.members.gatsbyImageData,
      mobileImage: assets.membersMobile.gatsbyImageData,
    },
    {
      title: 'Feed',
      image: assets.feed.gatsbyImageData,
      mobileImage: assets.feedMobile.gatsbyImageData,
    },
    {
      title: 'Courses',
      videoUrl: assets.coursesVideo.file.url,
      posterUrl: assets.coursesVideoPoster.file.url,
      mobileImage: assets.coursesMobile.gatsbyImageData,
    },
    {
      title: 'Events',
      image: assets.events.gatsbyImageData,
      mobileImage: assets.eventsMobile.gatsbyImageData,
    },
    {
      title: 'Live',
      image: assets.live.gatsbyImageData,
      mobileImage: assets.liveMobile.gatsbyImageData,
    },
    {
      title: 'Chat',
      image: assets.chat.gatsbyImageData,
      mobileImage: assets.chatMobile.gatsbyImageData,
    },
    {
      title: 'Analytics',
      image: assets.analytics.gatsbyImageData,
      mobileImage: assets.analyticsMobile.gatsbyImageData,
    },
  ];

  return (
    <ScreenSwap
      screens={screens}
      staticScale={staticScale}
    />
  );
};

export default HeroScreenSwap;
